"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/cms_service.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSOrderServiceGetSalesBreakdownByMonthResponse = exports.CMSOrderServiceGetSalesBreakdownByMonthRequest = exports.CMSOrderServiceCancelGoodsOrderResponse = exports.CMSOrderServiceCancelGoodsOrderRequest = exports.CMSOrderServiceUpdateGoodsOrderCommentResponse = exports.CMSOrderServiceUpdateGoodsOrderCommentRequest = exports.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse = exports.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest = exports.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item = exports.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse = exports.CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest = exports.CMSOrderServiceGetGoodsOrderResponse = exports.CMSOrderServiceGetGoodsOrderRequest = exports.CMSOrderServiceGetBankAccountResponse = exports.CMSOrderServiceGetBankAccountRequest = exports.CMSOrderServiceSaveBankAccountResponse = exports.CMSOrderServiceSaveBankAccountRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const cms_common_pb_1 = require("./cms_common_pb");
/**
 * @generated from message spwn.order.v1.CMSOrderServiceSaveBankAccountRequest
 */
class CMSOrderServiceSaveBankAccountRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceSaveBankAccountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceSaveBankAccountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceSaveBankAccountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceSaveBankAccountRequest, a, b);
    }
}
exports.CMSOrderServiceSaveBankAccountRequest = CMSOrderServiceSaveBankAccountRequest;
CMSOrderServiceSaveBankAccountRequest.runtime = protobuf_1.proto3;
CMSOrderServiceSaveBankAccountRequest.typeName = "spwn.order.v1.CMSOrderServiceSaveBankAccountRequest";
CMSOrderServiceSaveBankAccountRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bank", kind: "message", T: cms_common_pb_1.CMSBankAccount },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceSaveBankAccountResponse
 */
class CMSOrderServiceSaveBankAccountResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceSaveBankAccountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceSaveBankAccountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceSaveBankAccountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceSaveBankAccountResponse, a, b);
    }
}
exports.CMSOrderServiceSaveBankAccountResponse = CMSOrderServiceSaveBankAccountResponse;
CMSOrderServiceSaveBankAccountResponse.runtime = protobuf_1.proto3;
CMSOrderServiceSaveBankAccountResponse.typeName = "spwn.order.v1.CMSOrderServiceSaveBankAccountResponse";
CMSOrderServiceSaveBankAccountResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetBankAccountRequest
 */
class CMSOrderServiceGetBankAccountRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetBankAccountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetBankAccountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetBankAccountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetBankAccountRequest, a, b);
    }
}
exports.CMSOrderServiceGetBankAccountRequest = CMSOrderServiceGetBankAccountRequest;
CMSOrderServiceGetBankAccountRequest.runtime = protobuf_1.proto3;
CMSOrderServiceGetBankAccountRequest.typeName = "spwn.order.v1.CMSOrderServiceGetBankAccountRequest";
CMSOrderServiceGetBankAccountRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetBankAccountResponse
 */
class CMSOrderServiceGetBankAccountResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetBankAccountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetBankAccountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetBankAccountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetBankAccountResponse, a, b);
    }
}
exports.CMSOrderServiceGetBankAccountResponse = CMSOrderServiceGetBankAccountResponse;
CMSOrderServiceGetBankAccountResponse.runtime = protobuf_1.proto3;
CMSOrderServiceGetBankAccountResponse.typeName = "spwn.order.v1.CMSOrderServiceGetBankAccountResponse";
CMSOrderServiceGetBankAccountResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bank", kind: "message", T: cms_common_pb_1.CMSBankAccount },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrderRequest
 */
class CMSOrderServiceGetGoodsOrderRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrderRequest, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrderRequest = CMSOrderServiceGetGoodsOrderRequest;
CMSOrderServiceGetGoodsOrderRequest.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrderRequest.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrderRequest";
CMSOrderServiceGetGoodsOrderRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrderResponse
 */
class CMSOrderServiceGetGoodsOrderResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrderResponse, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrderResponse = CMSOrderServiceGetGoodsOrderResponse;
CMSOrderServiceGetGoodsOrderResponse.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrderResponse.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrderResponse";
CMSOrderServiceGetGoodsOrderResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: cms_common_pb_1.CMSOrderGoods },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest
 */
class CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID
         *
         * @generated from field: repeated string goods_ids = 1;
         */
        this.goodsIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest = CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest;
CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest";
CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse
 */
class CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse.Item items = 1;
         */
        this.items = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse = CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse;
CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse";
CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse.Item
 */
class CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 対象のグッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 売上個数
         * グッズを購入している数
         *
         * @generated from field: int32 order_count = 2;
         */
        this.orderCount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item = CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item;
CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse.Item";
CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse_Item.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest
 */
class CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest = CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest;
CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest";
CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse
 */
class CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.CMSOrderGoods orders = 1;
         */
        this.orders = [];
        /**
         * @generated from field: repeated spwn.order.v1.CMSOrderGoodsStatus statuses = 2;
         */
        this.statuses = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse, a, b);
    }
}
exports.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse = CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse;
CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse.runtime = protobuf_1.proto3;
CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse.typeName = "spwn.order.v1.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse";
CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "orders", kind: "message", T: cms_common_pb_1.CMSOrderGoods, repeated: true },
    { no: 2, name: "statuses", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSOrderGoodsStatus), repeated: true },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceUpdateGoodsOrderCommentRequest
 */
class CMSOrderServiceUpdateGoodsOrderCommentRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * @generated from field: string comment = 2;
         */
        this.comment = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceUpdateGoodsOrderCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceUpdateGoodsOrderCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceUpdateGoodsOrderCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceUpdateGoodsOrderCommentRequest, a, b);
    }
}
exports.CMSOrderServiceUpdateGoodsOrderCommentRequest = CMSOrderServiceUpdateGoodsOrderCommentRequest;
CMSOrderServiceUpdateGoodsOrderCommentRequest.runtime = protobuf_1.proto3;
CMSOrderServiceUpdateGoodsOrderCommentRequest.typeName = "spwn.order.v1.CMSOrderServiceUpdateGoodsOrderCommentRequest";
CMSOrderServiceUpdateGoodsOrderCommentRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceUpdateGoodsOrderCommentResponse
 */
class CMSOrderServiceUpdateGoodsOrderCommentResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceUpdateGoodsOrderCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceUpdateGoodsOrderCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceUpdateGoodsOrderCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceUpdateGoodsOrderCommentResponse, a, b);
    }
}
exports.CMSOrderServiceUpdateGoodsOrderCommentResponse = CMSOrderServiceUpdateGoodsOrderCommentResponse;
CMSOrderServiceUpdateGoodsOrderCommentResponse.runtime = protobuf_1.proto3;
CMSOrderServiceUpdateGoodsOrderCommentResponse.typeName = "spwn.order.v1.CMSOrderServiceUpdateGoodsOrderCommentResponse";
CMSOrderServiceUpdateGoodsOrderCommentResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: cms_common_pb_1.CMSOrderGoods },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceCancelGoodsOrderRequest
 */
class CMSOrderServiceCancelGoodsOrderRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceCancelGoodsOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceCancelGoodsOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceCancelGoodsOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceCancelGoodsOrderRequest, a, b);
    }
}
exports.CMSOrderServiceCancelGoodsOrderRequest = CMSOrderServiceCancelGoodsOrderRequest;
CMSOrderServiceCancelGoodsOrderRequest.runtime = protobuf_1.proto3;
CMSOrderServiceCancelGoodsOrderRequest.typeName = "spwn.order.v1.CMSOrderServiceCancelGoodsOrderRequest";
CMSOrderServiceCancelGoodsOrderRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceCancelGoodsOrderResponse
 */
class CMSOrderServiceCancelGoodsOrderResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceCancelGoodsOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceCancelGoodsOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceCancelGoodsOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceCancelGoodsOrderResponse, a, b);
    }
}
exports.CMSOrderServiceCancelGoodsOrderResponse = CMSOrderServiceCancelGoodsOrderResponse;
CMSOrderServiceCancelGoodsOrderResponse.runtime = protobuf_1.proto3;
CMSOrderServiceCancelGoodsOrderResponse.typeName = "spwn.order.v1.CMSOrderServiceCancelGoodsOrderResponse";
CMSOrderServiceCancelGoodsOrderResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: cms_common_pb_1.CMSOrderGoods },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetSalesBreakdownByMonthRequest
 */
class CMSOrderServiceGetSalesBreakdownByMonthRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 year = 1;
         */
        this.year = 0;
        /**
         * @generated from field: int32 month = 2;
         */
        this.month = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetSalesBreakdownByMonthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetSalesBreakdownByMonthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetSalesBreakdownByMonthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetSalesBreakdownByMonthRequest, a, b);
    }
}
exports.CMSOrderServiceGetSalesBreakdownByMonthRequest = CMSOrderServiceGetSalesBreakdownByMonthRequest;
CMSOrderServiceGetSalesBreakdownByMonthRequest.runtime = protobuf_1.proto3;
CMSOrderServiceGetSalesBreakdownByMonthRequest.typeName = "spwn.order.v1.CMSOrderServiceGetSalesBreakdownByMonthRequest";
CMSOrderServiceGetSalesBreakdownByMonthRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.CMSOrderServiceGetSalesBreakdownByMonthResponse
 */
class CMSOrderServiceGetSalesBreakdownByMonthResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.CMSOrderSalesBreakdownItem sales_breakdown = 1;
         */
        this.salesBreakdown = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSOrderServiceGetSalesBreakdownByMonthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSOrderServiceGetSalesBreakdownByMonthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSOrderServiceGetSalesBreakdownByMonthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSOrderServiceGetSalesBreakdownByMonthResponse, a, b);
    }
}
exports.CMSOrderServiceGetSalesBreakdownByMonthResponse = CMSOrderServiceGetSalesBreakdownByMonthResponse;
CMSOrderServiceGetSalesBreakdownByMonthResponse.runtime = protobuf_1.proto3;
CMSOrderServiceGetSalesBreakdownByMonthResponse.typeName = "spwn.order.v1.CMSOrderServiceGetSalesBreakdownByMonthResponse";
CMSOrderServiceGetSalesBreakdownByMonthResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "sales_breakdown", kind: "message", T: cms_common_pb_1.CMSOrderSalesBreakdownItem, repeated: true },
]);
//# sourceMappingURL=cms_service_pb.js.map